import { useState, useEffect } from 'react';

export const useLoadImage = (imageUrl?: string | null) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!imageUrl) {
      setImageSrc(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setImageSrc(null);
    setError(null);

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      setImageSrc(imageUrl);
      setLoading(false);
    };

    img.onerror = (err) => {
      console.error('Failed to load image:', err);
      setError(new Error('Failed to load image'));
      setLoading(false);
    };

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [imageUrl]);

  return { imageSrc, loading, error };
};
